var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "genericErrorModal", role: "dialog", tabindex: "-1" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require(`.././../../assets/images/error@2x.jpg`),
                  srcset: `${require(`../../../assets/images/error@1x.jpg`)} 1x, ${require(`../../../assets/images/error@2x.jpg`)} 2x, ${require(`../../../assets/images/error@3x.jpg`)} 3x, ${require(`../../../assets/images/error@4x.jpg`)} 4x`,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm._f("trans")("Oops, Something Went Wrong"))),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")(
                        "It looks like there was an issue. We dispatched our seal team to solve this issue."
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm._f("trans")("Please try again later."))),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn close-btn",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-times mr-1" }),
                  _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Cancel")))]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }